package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SignSymptomName(private val literal: String) : IEnumType {
	脉浮("脉浮"),
	脉沉("脉沉"),
	脉数("脉数"),
	脉迟("脉迟"),
	脉弦("脉弦"),
	脉紧("脉紧"),
	脉滑("脉滑"),
	脉涩("脉涩"),
	脉洪("脉洪"),
	脉大("脉大"),
	脉细("脉细"),
	脉微("脉微"),
	脉弱("脉弱"),
	脉虚("脉虚"),
	脉实("脉实"),
	脉芤("脉芤"),
	脉革("脉革"),
	脉缓("脉缓"),
	脉动("脉动"),
	脉长("脉长"),
	脉短("脉短"),
	脉促("脉促"),
	脉结("脉结"),
	脉代("脉代"),
	脉平("脉平"),
	脉绝("脉绝"),
	舌体瘦小("舌体瘦小"),
	舌体胖大边有齿痕("舌体胖大边有齿痕"),
	舌色淡红("舌色淡红"),
	舌色淡白("舌色淡白"),
	舌尖舌边红("舌尖舌边红"),
	舌色红("舌色红"),
	舌色绛("舌色绛"),
	舌色青紫("舌色青紫"),
	舌下静脉怒张("舌下静脉怒张"),
	舌上无苔("舌上无苔"),
	舌苔白("舌苔白"),
	舌苔暗黑("舌苔暗黑"),
	舌苔黄("舌苔黄"),
	舌苔少("舌苔少"),
	舌苔薄("舌苔薄"),
	舌苔厚腻("舌苔厚腻"),
	舌苔腐垢("舌苔腐垢"),
	舌干("舌干"),
	舌润("舌润"),
	舌苔水滑欲滴("舌苔水滑欲滴"),
	舌中有裂纹("舌中有裂纹"),
	发热("发热"),
	潮热("潮热"),
	恶寒("恶寒"),
	恶风("恶风"),
	寒战("寒战"),
	往来寒热("往来寒热"),
	怕热("怕热"),
	有汗("有汗"),
	无汗("无汗"),
	自汗("自汗"),
	盗汗("盗汗"),
	脱汗("脱汗"),
	疲劳("疲劳"),
	身重("身重"),
	疲乏无力("疲乏无力"),
	身痒("身痒"),
	虫爬感("虫爬感"),
	烦热("烦热"),
	出血("出血"),
	水肿("水肿"),
	疼痛("疼痛"),
	身痛("身痛"),
	休克("休克"),
	发育迟缓("发育迟缓"),
	肥胖("肥胖"),
	消瘦("消瘦"),
	易饿("易饿"),
	身黄("身黄"),
	晕厥和虚脱("晕厥和虚脱"),
	淋巴结增大("淋巴结增大"),
	失眠("失眠"),
	嗜睡("嗜睡"),
	多梦("多梦"),
	味觉减退("味觉减退"),
	嗅觉减退("嗅觉减退"),
	行走困难("行走困难"),
	抖动("抖动"),
	气上冲("气上冲"),
	头晕("头晕"),
	眩晕("眩晕"),
	肢体瘫痪("肢体瘫痪"),
	梦呓("梦呓"),
	梦交("梦交"),
	梦游("梦游"),
	言语障碍("言语障碍"),
	癫痫发作("癫痫发作"),
	脱发("脱发"),
	头痛("头痛"),
	头重("头重"),
	面色晦暗("面色晦暗"),
	面色发红("面色发红"),
	面色发白("面色发白"),
	面色发青("面色发青"),
	面色萎黄("面色萎黄"),
	面起斑纹("面起斑纹"),
	口水多("口水多"),
	牙疼("牙疼"),
	牙齿松脱("牙齿松脱"),
	牙龈肿大("牙龈肿大"),
	牙龈脓肿("牙龈脓肿"),
	磨牙("磨牙"),
	牙关紧闭("牙关紧闭"),
	口腔溃疡("口腔溃疡"),
	口渴("口渴"),
	口臭("口臭"),
	口苦("口苦"),
	口干舌燥("口干舌燥"),
	口唇青紫("口唇青紫"),
	舌痛("舌痛"),
	红眼("红眼"),
	眼角发黑("眼角发黑"),
	两目黯黑("两目黯黑"),
	眼干涩("眼干涩"),
	眼肿大("眼肿大"),
	眼分泌物("眼分泌物"),
	巩膜黄染("巩膜黄染"),
	眼痛("眼痛"),
	眼花("眼花"),
	视物不清("视物不清"),
	飞蚊症("飞蚊症"),
	眼肌瘫痪("眼肌瘫痪"),
	眼球突出("眼球突出"),
	前房积脓("前房积脓"),
	耳堵塞感("耳堵塞感"),
	耳鸣("耳鸣"),
	耳聋("耳聋"),
	耳漏("耳漏"),
	耳出血("耳出血"),
	耳痛("耳痛"),
	鼻鼾("鼻鼾"),
	鼻塞("鼻塞"),
	鼻干("鼻干"),
	鼻衄("鼻衄"),
	鼻头色青("鼻头色青"),
	鼻头色黑("鼻头色黑"),
	流涕("流涕"),
	鼻流清涕("鼻流清涕"),
	鼻流浊涕("鼻流浊涕"),
	咽喉干燥("咽喉干燥"),
	咽痛("咽痛"),
	咽红肿("咽红肿"),
	咽红("咽红"),
	咽喉肿大("咽喉肿大"),
	咽中生疮("咽中生疮"),
	咽痒("咽痒"),
	咽中异物感("咽中异物感"),
	咽喉部出血("咽喉部出血"),
	声音嘶哑("声音嘶哑"),
	失音("失音"),
	肩颈僵痛不适("肩颈僵痛不适"),
	背强("背强"),
	手心发热("手心发热"),
	脚心发热("脚心发热"),
	身冷("身冷"),
	手足冰冷("手足冰冷"),
	手足温("手足温"),
	膝冷("膝冷"),
	膝痛("膝痛"),
	手脚屈伸不便("手脚屈伸不便"),
	四肢活动受限("四肢活动受限"),
	手关节肿("手关节肿"),
	手关节痛("手关节痛"),
	手腕酸痛("手腕酸痛"),
	手肘酸痛("手肘酸痛"),
	四肢酸痛("四肢酸痛"),
	髋关节痛("髋关节痛"),
	腿痛("腿痛"),
	踝关节肿("踝关节肿"),
	踝关节痛("踝关节痛"),
	脚肿("脚肿"),
	灰指甲("灰指甲"),
	灰趾甲("灰趾甲"),
	甲沟炎("甲沟炎"),
	背痛("背痛"),
	背麻("背麻"),
	背冷("背冷"),
	腰痛("腰痛"),
	腰酸软("腰酸软"),
	腰无力("腰无力"),
	腰重("腰重"),
	腰冷("腰冷"),
	胸闷("胸闷"),
	胸痛("胸痛"),
	胸部按痛("胸部按痛"),
	胸中甲错("胸中甲错"),
	胁痛("胁痛"),
	胁胀满("胁胀满"),
	胁下按之硬("胁下按之硬"),
	膈内剧痛("膈内剧痛"),
	心悸("心悸"),
	怔忡("怔忡"),
	胃脘悸动("胃脘悸动"),
	脐下悸动("脐下悸动"),
	心脏压迫感或紧束感("心脏压迫感或紧束感"),
	腹部压痛("腹部压痛"),
	盆腔或会阴痛("盆腔或会阴痛"),
	腹痛("腹痛"),
	心下按之不软("心下按之不软"),
	腹内或盆腔肿块("腹内或盆腔肿块"),
	胃脘满闷("胃脘满闷"),
	胃脘隐痛("胃脘隐痛"),
	胃脘挛痛("胃脘挛痛"),
	腹胀满("腹胀满"),
	少腹满("少腹满"),
	少腹拘挛("少腹拘挛"),
	少腹硬("少腹硬"),
	少腹痛("少腹痛"),
	少腹肿痞("少腹肿痞"),
	少腹冷("少腹冷"),
	少腹麻痹("少腹麻痹"),
	腹强直("腹强直"),
	腹绵薄("腹绵薄"),
	肠鸣("肠鸣"),
	腹水("腹水"),
	恶心("恶心"),
	呕吐("呕吐"),
	干呕("干呕"),
	嗳气("嗳气"),
	消化不良("消化不良"),
	食不下("食不下"),
	反酸("反酸"),
	烧心("烧心"),
	呕血("呕血"),
	便秘("便秘"),
	便溏("便溏"),
	腹泻("腹泻"),
	急腹症("急腹症"),
	大便失禁("大便失禁"),
	排便不尽("排便不尽"),
	里急后重("里急后重"),
	胃肠胀气("胃肠胀气"),
	可见性蠕动("可见性蠕动"),
	便血("便血"),
	便脓("便脓"),
	胃肠出血("胃肠出血"),
	肛门溃疡("肛门溃疡"),
	肛门和直肠出血("肛门和直肠出血"),
	痔疮出血("痔疮出血"),
	数日不排便("数日不排便"),
	黑便("黑便"),
	有屁("有屁"),
	消化系统梗阻("消化系统梗阻"),
	肝大或脾大("肝大或脾大"),
	消化系统脓肿("消化系统脓肿"),
	消化系统瘘("消化系统瘘"),
	消化系统穿孔("消化系统穿孔"),
	消化系统狭窄("消化系统狭窄"),
	消化系统溃疡("消化系统溃疡"),
	消化系统扩张("消化系统扩张"),
	消化系统嵌顿("消化系统嵌顿"),
	消化系统绞窄或坏疽("消化系统绞窄或坏疽"),
	皮疹("皮疹"),
	皮肤溃疡("皮肤溃疡"),
	皮肤角化("皮肤角化"),
	表皮剥脱("表皮剥脱"),
	紫癜("紫癜"),
	红斑("红斑"),
	白斑("白斑"),
	发绀("发绀"),
	苍白("苍白"),
	淤点("淤点"),
	潮红("潮红"),
	皮肤烧灼感("皮肤烧灼感"),
	皮肤瘙痒("皮肤瘙痒"),
	皮肤痛或压痛("皮肤痛或压痛"),
	皮肤刺痛("皮肤刺痛"),
	皮肤麻刺感("皮肤麻刺感"),
	肌肤甲错("肌肤甲错"),
	肌肤麻痹("肌肤麻痹"),
	皮肤松弛("皮肤松弛"),
	关节僵硬("关节僵硬"),
	关节痛("关节痛"),
	关节肿("关节肿"),
	肌痛("肌痛"),
	弹响髋("弹响髋"),
	肌强直("肌强直"),
	角弓反张("角弓反张"),
	坐骨神经痛("坐骨神经痛"),
	痉挛("痉挛"),
	跌倒倾向("跌倒倾向"),
	骨坏死("骨坏死"),
	骨赘("骨赘"),
	神昏("神昏"),
	精神恍惚("精神恍惚"),
	精神失常("精神失常"),
	卧起不安("卧起不安"),
	谵语("谵语"),
	行动如狂("行动如狂"),
	昏迷("昏迷"),
	情绪低落("情绪低落"),
	抑郁心境("抑郁心境"),
	狂妄("狂妄"),
	狂躁不安("狂躁不安"),
	健忘("健忘"),
	注意力下降("注意力下降"),
	思维迟钝("思维迟钝"),
	爱哭("爱哭"),
	心烦("心烦"),
	烦躁("烦躁"),
	易惊("易惊"),
	惊恐发作("惊恐发作"),
	易激惹("易激惹"),
	妄想("妄想"),
	幻觉("幻觉"),
	食欲正常("食欲正常"),
	食欲亢进("食欲亢进"),
	食欲下降("食欲下降"),
	多饮("多饮"),
	多食("多食"),
	大小便失禁("大小便失禁"),
	高血压("高血压"),
	低血压("低血压"),
	心动过速("心动过速"),
	心动过缓("心动过缓"),
	无痰("无痰"),
	黄痰("黄痰"),
	白痰("白痰"),
	绿痰("绿痰"),
	多痰("多痰"),
	少量痰("少量痰"),
	脓痰("脓痰"),
	泡沫痰("泡沫痰"),
	清稀痰("清稀痰"),
	浓稠痰("浓稠痰"),
	喘息("喘息"),
	气短("气短"),
	呼吸微弱("呼吸微弱"),
	呃逆("呃逆"),
	气逆("气逆"),
	喷嚏("喷嚏"),
	哮鸣音("哮鸣音"),
	打哈欠("打哈欠"),
	咳嗽("咳嗽"),
	干咳无痰("干咳无痰"),
	平卧咳嗽加重("平卧咳嗽加重"),
	咯血("咯血"),
	咯脓血("咯脓血"),
	肺胀满("肺胀满"),
	乳房肿块("乳房肿块"),
	乳房胀痛("乳房胀痛"),
	阴道分泌物("阴道分泌物"),
	闭经("闭经"),
	阴吹("阴吹"),
	阴痒("阴痒"),
	子宫频繁出血("子宫频繁出血"),
	子宫脱垂("子宫脱垂"),
	阴茎痛("阴茎痛"),
	前列腺不适("前列腺不适"),
	急性阴囊痛("急性阴囊痛"),
	睾丸痛("睾丸痛"),
	遗精("遗精"),
	阴囊潮湿("阴囊潮湿"),
	阴疮("阴疮"),
	阴冷("阴冷"),
	尿频("尿频"),
	尿失禁("尿失禁"),
	遗尿("遗尿"),
	尿潴留("尿潴留"),
	尿外渗("尿外渗"),
	多尿("多尿"),
	无尿或少尿("无尿或少尿"),
	排尿困难("排尿困难"),
	泌尿结石("泌尿结石"),
	小便色清("小便色清"),
	小便色黄("小便色黄"),
	小便色赤("小便色赤"),
	排尿头痛("排尿头痛"),
	排尿毛耸("排尿毛耸"),
	排尿头晕("排尿头晕"),
	小便涩痛("小便涩痛"),
	血尿("血尿"),
	膀胱痛("膀胱痛"),
	肾绞痛("肾绞痛"),
	经前焦虑("经前焦虑"),
	经前抑郁("经前抑郁"),
	产后抑郁("产后抑郁"),
	产后潮热("产后潮热"),
	哺乳期无乳或少乳("哺乳期无乳或少乳"),
	更年期潮热("更年期潮热"),
	月经先期("月经先期"),
	月经后期("月经后期"),
	行经持续时间过长("行经持续时间过长"),
	行经持续时间过短("行经持续时间过短"),
	月经量多("月经量多"),
	月经量少("月经量少"),
	月经色淡("月经色淡"),
	月经色暗红("月经色暗红"),
	月经夹血块("月经夹血块"),
	性欲低下("性欲低下"),
	女性性唤起功能障碍("女性性唤起功能障碍"),
	男性勃起功能障碍("男性勃起功能障碍"),
	性高潮缺失("性高潮缺失"),
	男性早泄("男性早泄"),
	男性射精延迟("男性射精延迟"),
	阴道痉挛("阴道痉挛"),
	性交痛("性交痛"),
	梅毒("梅毒"),
	淋球菌感染("淋球菌感染"),
	衣原体引起的性传播感染("衣原体引起的性传播感染"),
	软下疳("软下疳"),
	腹股沟肉芽肿("腹股沟肉芽肿"),
	毛滴虫病("毛滴虫病"),
	疥疮("疥疮"),
	生殖器或泌尿生殖道单纯疱疹病毒感染("生殖器或泌尿生殖道单纯疱疹病毒感染"),
	肛门疣("肛门疣"),
	生殖器疣("生殖器疣"),
	外生殖器尖锐湿疣("外生殖器尖锐湿疣"),
	生殖器疱疹("生殖器疱疹"),
	单纯疱疹性龈口炎("单纯疱疹性龈口炎"),
	外阴阴道念珠菌病("外阴阴道念珠菌病"),
	念珠菌龟头包皮炎("念珠菌龟头包皮炎"),
	艾滋病("艾滋病"),
	其它性病("其它性病"),
	局部创伤("局部创伤"),
	烧伤("烧伤"),
	冻伤("冻伤"),
	异物入侵("异物入侵"),
	中毒("中毒"),
	容易感冒("容易感冒"),
	容易口腔溃疡("容易口腔溃疡"),
	感冒("感冒"),
	发烧("发烧"),
	骨质增生("骨质增生"),
	心力衰竭("心力衰竭"),
	风湿性心脏病("风湿性心脏病"),
	神经性头晕("神经性头晕"),
	黄体功能不全("黄体功能不全"),
	不孕("不孕"),
	不育("不育"),
	高血脂("高血脂"),
	糖尿病("糖尿病"),
	乳糜尿("乳糜尿"),
	脑卒中("脑卒中"),
	痛经("痛经"),
	输卵管阻塞("输卵管阻塞");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "sign_symptom_name"}
	override fun getLiteral(): String {return literal}
}
